import { IReduxStore } from "Redux/Store/IReduxStore";
import {
    CREATE_FILE_REFERENCE_FAILURE,
    FIND_FILE_REFERENCES_FAILURE,
    SEARCH_FILE_REFERENCES_FAILURE,
} from 'Redux/Action';
import { ArrayContains } from 'ClientService';

export const isFileReferenceFailed = (state: IReduxStore): boolean => ArrayContains(state.fileReference.failedRequests, [
    CREATE_FILE_REFERENCE_FAILURE,
    FIND_FILE_REFERENCES_FAILURE,
    SEARCH_FILE_REFERENCES_FAILURE,
]);
